export default "/site/aidive/js/react/dist/images/olympiacos-hero-mobile.a8a26ab4.jpg";